export default "__VITE_ASSET__fa791eee__"